export default __webpack_public_path__ + "static/media/statistics.a669acd1.png";